import React from 'react';

import classNames from 'classnames';

import { t, T } from '@web-solutions/module-localization';
import styles from './style.module.scss';

type Variant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p1' | 'p2' | 'p3' | 'p4' | 'p5';

export interface TextProps {
  children?: string;
  variant?: Variant;
  as?: keyof React.JSX.IntrinsicElements;
  className?: string;
  highlightColor?: string;
  isCenter?: boolean;
  style?: object;
}

const Text: React.FC<TextProps> = ({
  children,
  variant = 'text1',
  highlightColor,
  as,
  className,
  isCenter,
  style,
  //@ts-ignore
  tOptions = {},
  //@ts-ignore
  components = {},
}) => {
  const Tag =
    as || ((variant.startsWith('h') ? variant : 'p') as keyof React.JSX.IntrinsicElements);

  if (!children && typeof children !== 'string') return <></>;

  return (
    <Tag
      className={classNames(styles.default, { [styles.center]: isCenter }, variant, className)}
      style={
        { ...style, '--color-highlight': `var(--color-${highlightColor})` } as Record<
          string,
          string
        >
      }
    >
      <T
        k={children}
        values={Object.entries(tOptions).reduce(
          (acc, [key, i]) => ({ ...acc, [key]: t(String(i)) }),
          {}
        )}
        components={components}
      />
    </Tag>
  );
};

export default Text